import { decodeVacancy } from 'models/Vacancy';
import { ServerApi } from 'modules/api/server-api';

export const fetchCompanyVacancy = (api: ServerApi) => async (vacancyId: string | number) => {
  const response = await api.get(`/company/vacancies/${vacancyId}`);
  return decodeVacancy(response.data);
};
